import { CcdIntervalleModel } from '@cnaf.usagers.appli/cnaf-commons-dral';

export class ConstantesEligibilite {

  /**
   * Codes postaux interdits : 
   * 975xx et tous ceux après 97700
   */
  public static INTERVALLES_CODES_POSTAUX_NON_ELIGIBLES : Array<CcdIntervalleModel> = 
  [
    new CcdIntervalleModel(97500, 97599),
    new CcdIntervalleModel(97700, Number.MAX_SAFE_INTEGER)
  ];
}
